import { createApi } from '@reduxjs/toolkit/query/react';

import { ResponseError } from '@/types/Error';
import { SuccessResponse } from '@/types/Success';

import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

const contentTypes = {
  applicationJson: 'application/json',
};

export const newsletterApi = createApi({
  reducerPath: 'newsletterApi',
  keepUnusedDataFor: 300,
  // baseQuery: fetchBaseQuery({
  //   baseUrl: `${SERVER_URL}/Marketing`,
  //   prepareHeaders: headers => {
  //     const { origin, host } = globalThis.window?.location || {};
  //     headers.append('Origin', origin);
  //     headers.append('Host', host);
  //     headers.append('__Origin', origin);
  //     return headers;
  //   },
  // }),

  baseQuery: generateBaseQuseryWithReAuth({ basePath: 'Marketing' }),

  tagTypes: ['NewsletterSignUp'],
  endpoints: builder => ({
    newsletterSignUp: builder.mutation<
      SuccessResponse<unknown>,
      { firstName: string; lastName: string; email: string; webalias: string }
    >({
      query: payload => ({
        url: `/CreateCustomer`,
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Content-Type': contentTypes.applicationJson,
        },
      }),
      transformResponse: (response: SuccessResponse<unknown>, meta, arg) => response,
      transformErrorResponse: response => response as ResponseError,
    }),
  }),
});

export const { useNewsletterSignUpMutation } = newsletterApi;
